
import {defineComponent, PropType} from 'vue';
import IconButton from '@ohrm/oxd/core/components/Button/Icon.vue';
import DropdownMenu from '@ohrm/oxd/core/components/DropdownMenu/DropdownMenu.vue';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import {ActionCellEvent, DropdownOption} from './types';

export default defineComponent({
  name: 'oxd-table-dropdown',
  props: {
    options: {
      type: Array as PropType<DropdownOption[]>,
      default: () => [],
    },
  },
  components: {
    'oxd-icon-button': IconButton,
    'oxd-dropdown-menu': DropdownMenu,
    'oxd-text': Text,
  },
  methods: {
    noOp(e: MouseEvent) {
      // stop event bubbling and prevent emiting event until selected
      e.stopImmediatePropagation();
    },
    onClick(e: MouseEvent, context: string) {
      const event: ActionCellEvent = e;
      event.context = context;
      this.$emit('click', event);
    },
  },
});
